import React, { useEffect, useState } from "react";
// images
import AgentNotReady from "../../Assets/images/dashboard/agentnotready.svg";
import LoggedInAgents from "../../Assets/images/dashboard/LoggedInAgents.svg";
import AgentActive from "../../Assets/images/dashboard/AgentActiveDash.svg";
import agentOffline from "../../Assets/images/dashboard/agentOffline.svg";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
// mui
import {
  Typography,
  Box,
  Pagination,
  Stack,
  Chip,
  Grid,
  Paper,
  TableContainer,
  TableBody,
  Table,
  TableRow,
  TableHead,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Select,
  FormControl,
} from "@mui/material";
import Popover from "@mui/material/Popover";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { useNavigate, useOutletContext } from "react-router-dom";
import Badge from "@mui/material/Badge";
import moment from "moment";
// icons
import { FaClock, FaBusinessTime } from "react-icons/fa";
import QuickreplyIcon from "@mui/icons-material/Quickreply";
import { TiWarningOutline } from "react-icons/ti";
import {
  ArrowsIn,
  ArrowsOut,
  ChatsCircle,
  Envelope,
  FacebookLogo,
  Phone,
  Robot,
  TwitterLogo,
  VideoCamera,
  WhatsappLogo,
} from "@phosphor-icons/react";
// other
import {
  AvcUrl,
  BaseUrl,
  PowerBiurl,
  VoiceDomainName,
  VoiceDomainNamePure,
} from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { endInteraction, setsidebarVal } from "../../Redux/Actions/actions";
// component import
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Eye, SignOut } from "@phosphor-icons/react";
import Tooltip from "@mui/material/Tooltip";
import { toaststyle } from "../../Utils/toaststyle";
import { Spinner } from "react-bootstrap";
import { CiFilter } from "react-icons/ci";
import { IoFilter } from "react-icons/io5";

const StyledPaper = styled(Paper)(({ theme }) => ({
  height: "100%",
  padding: "10px 10px 50px 10px",
  background: "none",
  boxShadow: "none",
  borderRadius: "none",
}));


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "",
    color: theme.palette.common.black,
    padding: "8px",
    fontWeight: 600,
    borderBottom: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));
const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: "#FFFF",
    color: theme.palette.common.black,
    padding: "20px 8px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const StyledTableCell3 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: "#FFFF",
    color: theme.palette.common.black,
    padding: "5px 8px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
    agentStatusrefreash: state.data.agentStatusrefreash,
    showingStatus: state.contactListData.showingStatus,
    voicePlatForm: state.voice.voicePlatForm,
  };
};


const SupervisorDashboard = (props) => {
  const [callObj2, callmap, playMsgTone, stopwatch1, stopwatch2, WebSocket] =
    useOutletContext();
  const navigate = useNavigate();
  const LoggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  let permission = JSON.parse(localStorage.getItem("permission"));

  const [dashboardcount, setDashboardcount] = useState([]);
  const [teamactivitydashboardcount, setTeamactivitydashboardcount] = useState(
    []
  );
  const [loader, setloader] = useState(false);
  const [dashboardcountagent, setDashboardcountagent] = useState([]);
  const [OngoingInteractionList, setOngoingInteractionList] = useState([]);
  const [TotalqueueCount, setTotalqueueCount] = useState("");
  const [OngoingInteraction, setOngoingInteraction] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [page, setpage] = useState(1);
  const [userstatus, setUserstatus] = useState([]);
  const [showAllUserList, setshowAllUserList] = useState(true);
  const [anchorEl, setAnchorEl] = useState({});
  const openPopover = (index) => Boolean(anchorEl[index]);
  const [open2, setOpen2] = useState(false);

  return (
    <StyledPaper elevation={0}>
<Box
  display="flex"
  alignItems="center"
  justifyContent="space-between"
  mb={1}
  flexWrap="wrap"
  gap={2}
>
  <Typography variant="h6" fontWeight={600}>
    Dashboard
  </Typography>

  <Stack direction="row" spacing={1} alignItems="center">
    <FormControl size="small" sx={{ minWidth: 150 }}>
      <Select
        native
        defaultValue="Select Tenant"
        sx={{
          fontSize: "13px",
          height: "28px",
          backgroundColor: "#fff",
          borderRadius: "6px",
        }}
      >
        <option value="All">Select Tenant</option>
        <option value="Agent">Agent</option>
        <option value="Supervisor">Supervisor</option>
      </Select>
    </FormControl>

    <Button
      variant="contained"
      size="small"
      sx={{
        height: "28px",
        fontSize: "12px",
        textTransform: "none",
        padding: "0px 10px",
      }}
    >
      Submit
    </Button>
  </Stack>
</Box>

    <Grid container spacing={2} direction={"column"}>
      {showAllUserList && (
        <Grid item xs={12} md={12} sm={12}>
          <Grid container spacing={1} direction={"row"}>
            {[
              { item: 0, title: "Agents - LoggedIn" },
              { item: 1, title: "Agents - Active" },
              { item: 2, title: "Agents - Offline" },
              { item: 3, title: "Agents Not Ready" },
              //  { item: 6, title: "Longest Wait - Digital" },
            ].map((item) => (
              <Grid item xs={2} md={3} sm={4} key={item.item}>
                <div className="center">
                  <div className="design1"
                    style={{
                        backgroundColor: (() => {
                          switch (item.title) {
                            case "Agents - LoggedIn":
                              return "#e6f4ea";
                            case "Agents - Active":
                              return "#e6f0ff";
                            case "Agents - Offline":
                              return "#fbe9e7";
                            case "Agents Not Ready":
                              return "#fff3e0";
                            default:
                              return "#f5f5f5";
                          }
                        })(),
                        borderRadius: "12px",
                        padding: "10px",
                        position: "relative",
                        overflow: "hidden",
                      }}
                  
                  >
                    <Box
                      sx={{
                        width: "80%",
                        position: "absolute",
                        top: "20px",
                        left: "20px",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          color: "black",
                          fontSize: "16px",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className="d-flex align-items-center"
                      >
                        <FaClock className="me-2" />
                        {(() => {
                          switch (item.title) {
                            case "Agents - LoggedIn":
                              return (
                                <>
                                  {dashboardcount.AgentLoggedIn == null ||
                                  dashboardcount.AgentLoggedIn ==
                                    undefined
                                    ? 0
                                    : dashboardcount.AgentLoggedIn}
                                </>
                              );
                            case "Agents - Active":
                              return (
                                <>
                                  {dashboardcount.AgentActive == null ||
                                  dashboardcount.AgentActive == undefined
                                    ? 0
                                    : dashboardcount.AgentActive}
                                </>
                              );
                            case "Agents - Offline":
                              return (
                                <>
                                  {dashboardcount.AgentOffline == null ||
                                  dashboardcount.AgentOffline == null
                                    ? 0
                                    : dashboardcount.AgentOffline}
                                </>
                              );
                            case "Agents Not Ready":
                              return (
                                <>
                                  {" "}
                                  {dashboardcount.AgentNotReady == null ||
                                  dashboardcount.AgentNotReady ==
                                    undefined
                                    ? 0
                                    : dashboardcount.AgentNotReady}
                                </>
                              );
                            default:
                              return "";
                          }
                        })()}
                      </Typography>
                    </Box>

                    <div className="circle-1 center">
                      <div className="circle-2 center color-border">
                        <div className="circle-3 center color-border">
                          <div className="circle-4 center color-border">
                            <div className="circle-5">
                              <img
                                src={(() => {
                                  switch (item.title) {
                                    case "Agents - LoggedIn":
                                      return LoggedInAgents;
                                    case "Agents - Active":
                                      return AgentActive;
                                    case "Agents - Offline":
                                      return agentOffline;
                                    case "Agents Not Ready":
                                      return AgentNotReady;
                                    default:
                                      return "";
                                  }
                                })()}
                                className="dashboard-icons"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
      <Grid item xs={12} md={12} sm={12}>
        <div
          className="card-dash card"
          style={{ height: "62vh" }}
        >
          <div className="card-header d-flex align-items-center justify-content-between">
          </div>
          <div className="card-body pt-0">
            <TableContainer sx={{ height: "100%", width: "100%" }}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="">Agent Name</StyledTableCell>
                    <StyledTableCell align="center">
                      Status
                    </StyledTableCell>

                    <StyledTableCell align="center">
                      Ongoing Interaction
                    </StyledTableCell>


                  </TableRow>
                </TableHead>
                <TableBody>
                  {teamactivitydashboardcount.length > 0 ? (
                    teamactivitydashboardcount.map((item, index) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                      >
                        <StyledTableCell2>

                        </StyledTableCell2>

                        <StyledTableCell2 align="center">
                          <Chip
                            aria-describedby={id(index)}
                            onClick={(event) => {
                              if (
                                item.agent_id.id !=
                                  LoggedInAgent.agent_id ||
                                item.agent_id.agent_status_real ===
                                  "InCall"
                              ) {
                                handleClick(event, index);
                              }
                            }}
                            size="small"
                            label={item.agent_id.agent_status_real}
                            color={
                              item.agent_id.agent_status_real ==
                                "Available" ||
                              item.agent_id.agent_status_real == "Ready"
                                ? "success"
                                : item.agent_id.agent_status_real ==
                                    "Connected"
                                  ? "default"
                                  : "error"
                            }
                            sx={{
                              height: "15px",
                              width: "90px",
                              "& .MuiChip-label": {
                                fontSize: "10px",
                              },
                            }}
                          />
                        </StyledTableCell2>


                        <StyledTableCell2 align="center">
                          <IconButton
                            disabled={item.total_active ? false : true}
                            onClick={() => {
                              if (
                                item.agent_id.id != LoggedInAgent.agent_id
                              ) {
                                openOngoingInteractionApi(
                                  item.agent_id.id
                                );
                                openOngoingInteractionDialogBox();
                              }
                            }}
                          >
                            <Badge
                              badgeContent={item.total_active}
                              color="warning"
                              sx={{ zIndex: "0" }}
                            >
                              <QuickreplyIcon color="primary" />
                            </Badge>
                          </IconButton>
                        </StyledTableCell2>
                      </TableRow>
                    ))
                  ) : (
                    // Data unavailable start
                    <Stack
                      sx={{
                        position: "absolute",
                        width: "100%",
                        height: "calc(100vh - 14rem)",
                      }}
                      justifyContent="center"
                      alignContent="center"
                    >
                      <Stack
                        className="text-muted"
                        direction="column"
                        justifyContent="center"
                        alignContent="center"
                      >
                        <span className="mx-auto">
                          <img
                            src={Nodata}
                            alt="pic"
                            style={{ width: "11rem", userSelect: "none" }}
                          />
                        </span>
                        <span className="mx-auto">
                          <h6
                            className="text-muted mt-3"
                            style={{ fontSize: "13px" }}
                          >
                            Data unavailable
                          </h6>
                        </span>
                      </Stack>
                    </Stack>
                    // Data unavailable end
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </Grid>
    </Grid>
  </StyledPaper>
  );
};

export default connect(mapStateToProps, {
  setsidebarVal,
  endInteraction,
})(SupervisorDashboard);
